module.exports = __webpack_public_path__ + "img/step2-3.962fd1c6.png";